import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminEditGalleryDetails from "../../Components/Admin/AdminEditGalleryDetails";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditGalaryDetailsPage = () => {
  return (
    <AdminEditGalleryDetails />
  );
};

export default AdminEditGalaryDetailsPage;
